'use client';

import React from 'react';
import Link from 'next/link';
import { formatPercentExt } from '@frontend/jetlend-core/src/formatters/formatUtils';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { wordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import Tooltip from '@frontend/jetlend-web-ui/src/ui/TooltipIcon/Tooltip';
import Image from '@app/components/Image/Image';
import arrowIcon from '@app/icons/arrow--green-large.svg';
import glossIcon from '@app/icons/gloss.svg';
import {
    ICourseInformationApiModel,
    IUserCoursesItemApiModel,
} from '@app/models/features/course';

import styles from './HeaderLastCourseBlock.module.scss';

export interface IProps {
    /**
     * Информация по курсу
     */
    courseInfo: ICourseInformationApiModel;
    /**
     * Пользовательская информация по последнему курсу
     */
    lastCourse: IUserCoursesItemApiModel;
}

/**
 * Компонент информации по, последнему прошедшему или на этапе прохождения, курсу
 */
const HeaderLastCourseBlock:React.FC<IProps> = props => {
    const {
        lastCourse,
        courseInfo,
    } = props;
    const progress = courseInfo?.blocks_count <= 0 ? 0 : lastCourse?.passed_blocks_count/courseInfo?.blocks_count;
    const notPassedLessonsCount = courseInfo?.blocks_count ? courseInfo?.blocks_count - lastCourse?.passed_blocks_count : 0;

    const firstBlockClassName = mergeClassNames([
        styles['item'],
        styles['first-block'],
    ]);

    const greenBlockClassName = mergeClassNames([
        styles['item'],
        styles['item--green'],
    ]);

    const planBlockClassName = mergeClassNames([
        styles['item'],
        styles['item--dev'],
    ]);

    const greenBlockLabelClassName = mergeClassNames([
        styles['label'],
        styles['label--white'],
    ]);

    const greenBlockTextClassName = mergeClassNames([
        styles['text'],
        styles['text--white'],
    ]);

    return (
        <div className={styles['container']}>
            <div className={firstBlockClassName}>
                <div>
                    <div className={styles['grey-text']}>Курс</div>
                    <div className={styles['title']}>{courseInfo?.title}</div>
                </div>
                <Link href={`/academy/courses/${courseInfo?.slug}`} className={styles['link']}>Продолжить</Link>
                <Link href={`/academy/courses/${courseInfo?.slug}`} className={styles['course-link']}>
                    <Tooltip title="Перейти к курсу">
                        <Image src={arrowIcon} alt="" width={24} height={24} />
                    </Tooltip>
                </Link>
            </div>

            <div className={planBlockClassName}>
                <div className={styles['weekly_plan']}>
                    <Image src={glossIcon} alt="" width={19} height={25} />
                    <span>В разработке</span>
                </div>
            </div>
            <div className={greenBlockClassName}>
                <div className={greenBlockLabelClassName}>
                    <span className={styles['label--large']}>{formatPercentExt(progress)}</span>
                    &nbsp;
                    из 100%
                </div>
                <div className={greenBlockTextClassName}>
                    Прогресс прохождения курса
                    «{courseInfo?.title}»
                </div>
            </div>
            <div className={greenBlockClassName}>
                <div className={greenBlockLabelClassName}>
                    <span className={styles['label--large']}>{notPassedLessonsCount}</span>
                    &nbsp;
                    {wordForm(notPassedLessonsCount, 'blocks')}
                </div>
                <div className={greenBlockTextClassName}>
                    Осталось до прохождения курса
                    «{courseInfo?.title}»
                </div>
            </div>
        </div>
    );
};

export default HeaderLastCourseBlock;
